
import { Constants } from "../Constants";


// a plugin controller controls plugins for a set of items (for example, a Scene, or a group of Transforms, or a collection of Photos [ie. the Photo Bucket])

export class PluginController {

    debug:boolean = Constants.debug_off;
    debugPrimary:string = Constants._red;
    debugSecondary:string = Constants._gray;

    // we can use this as a global GUID object
    __guid:string = null;

    pluginManager:any = null;

    config:any = {
        label: null,
        categories: [],
        filterByType: [],
        filterByDsType: [],
        filterByTrType: [],
        filterByFeature: [],
        filterByItemDsType: false,
        filterByItemTrType: false,
        createId: function ( item ) { return item.id }
    };

    cache:any = {};
    cacheDirty:boolean = false;

    show:boolean = false;

    id:string = '';
    label:string = '';

    public countActive:number = 0;
    public countAvailable:number = 0;

    // plugins active through this controller
    activePlugins:any = [];

    // lookup table for named instances
    lut:any = {};

    // some controllers can have a reference item (Object)
    item:any = null;

    // some controllers can control some components (one at a time, though)
    component:any = null;


    _config ( config:any = null ) {
        Object.keys(config).forEach(k => {
            if ( config[k] ) {
                this.config[k] = config[k];
            }
        });
    }

    constructor ( id:string, config:any = null, pluginManager:any = null ) {

        this.id = id;
        this.pluginManager = pluginManager;
        
        this.label = this.id;

        if ( this.debug ) { console.log ( "%c "+this.id+" %c CONSTRUCTOR()", this.debugPrimary, this.debugSecondary, this ); }


        
        // if there's a config coming in, transfer each config item to this controller (doing this to always make sure there are defaults)
        if ( config ) {
            this._config(config);
        }
        if ( this.config.label ) {
            this.label = this.config.label;
        }
        
    }

    // events

    __add_pre() {}
    __add_post() {}

    __update_pre() {}
    __update_post() {}

    __remove_pre() {}
    __remove_post() {}

    __remove_all_pre() {}
    __remove_all_post() {}

    injectComponent ( c:any = null ) {
        this.component = c;
        if ( this.debug ) { console.log('injected component', c, this ); }
    }

    // caching

    clearCache( item:any = null ) {
        if ( item ) {
            let itemId = this.config.createId(item);
            if ( this.cache[itemId] ) {
                delete this.cache[itemId];
            } else {
                this.createCache(itemId);
            }
            // console.log('cleared item cache', this.id, itemId );
            return;
        }
        this.cache = {};
        this.cacheDirty = false;
        // console.log('cleared whole cache', this.id );
    }

    getLabelById ( id:string ) {
        
    }

    getLabelByPlugin ( plugin:any ) {
        
    }

    syncWith ( item:any ) {

    }

    createCache ( itemId:string ) {
        this.cache[itemId] = { 
            total: null,
            available: null,
            active: null,
            shortcuts: null,
            totalDirty: true,
            availableDirty: true,
            activeDirty: true,
            shortcutsDirty: true
        };
    }

    updateCategories ( categories:any = null ) {
        if ( categories ) {
            this.config['categories'] = categories;
        }
    }

    shortcutSorter ( a, b ) {
        if ( a.name < b.name ){
            return -1;
        }
        if ( a.name > b.name ){
            return 1;
        }
        return 0;
    }

    calculatePluginState ( itemId:string, config:any, item:any = null ) {

        if ( ! this.cache[itemId] ) {
            this.createCache(itemId);
        }

        if ( this.cache[itemId].totalDirty ) {
            this.cache[itemId].total = this.pluginManager.getTotalPlugins ( config, item );
            this.cache[itemId].total.sort();
            this.cache[itemId].totalDirty = false;
        }

        if ( this.cache[itemId].activeDirty ) {
            this.cache[itemId].active = this.pluginManager.getActivePlugins ( config, item );
            this.cache[itemId].activeDirty = false;
        }

        if ( this.cache[itemId].availableDirty ) {
            this.cache[itemId].available = this.pluginManager.getAvailablePlugins ( config, item, this.cache[itemId].total, this.cache[itemId].active );
            this.cache[itemId].available.sort();
            this.cache[itemId].availableDirty = false;
        }
        
        if ( this.cache[itemId].shortcutsDirty ) {
            this.cache[itemId].shortcuts = this.pluginManager.getShortcutPlugins ( config, item, this.cache[itemId].available, this.cache[itemId].active );
            this.cache[itemId].shortcuts.sort( this.shortcutSorter );
            this.cache[itemId].shortcutsDirty = false;
        }
    }

    getActiveCount ( item:any ) {
        let itemId = this.config.createId(item);
        if ( ! this.cache[itemId] || this.cache[itemId].activeDirty ) {
            this.calculatePluginState ( itemId, this.config, item );
        }
        return this.cache[itemId].active.length;
    }

    listTotal ( item:any ) {

        // got an item?
        if ( ! item ) { return []; }

        // id for this entry
        let itemId = this.config.createId(item);

        if ( ! this.cache[itemId] || this.cache[itemId].totalDirty ) {
            this.calculatePluginState ( itemId, this.config, item );
            // console.log('pc :: listTotal for item='+itemId, item.name, this.cache[itemId].total );
        }

        return this.cache[itemId].total;
    }

    listActive ( item:any = null ) {

        // got an item?
        if ( ! item ) { return []; }

        // id for this entry
        let itemId = this.config.createId(item);

        // console.log('pc :: listActive for item='+itemId );

        if ( ! this.cache[itemId] || this.cache[itemId].activeDirty ) {
            this.calculatePluginState ( itemId, this.config, item );
            // console.log('pc :: listActive for item='+itemId, item, this.cache[itemId].active );
        }

        return this.cache[itemId].active;
    }

    getActive ( item:any ) {
        let ret = [];
        if ( item ) {
            let items = this.listActive ( item );
            if ( items ) {
                items.forEach ( id => {
                    let plugin = this.pluginManager.get(id);
                    if ( plugin ) {
                        ret.push(plugin);
                    }
                });
            }
        }
        return ret;
    }

    isActive ( item:any, name:string ) {

        // got an item?
        if ( ! item ) { return []; }

        // id for this entry
        let itemId = this.config.createId(item);
        let cache = this.cache[itemId] ? this.cache[itemId].active : null;

        let ret = false;

        if ( cache ) {
            cache.forEach(pid => {
                let p = this.pluginManager.get(pid);
                // console.log('!!',pid,p.plugin_name,name, p.plugin_name == name);
                if ( p && p.plugin_name == name ) {
                    ret = p;
                }
            });
        }

        return ret;
    }

    listShortcuts ( item:any ) {

        // got an item?
        if ( ! item ) { return []; }

        // id for this entry
        let itemId = this.config.createId(item);

        if ( ! this.cache[itemId] || this.cache[itemId].shortcutsDirty ) {
            this.calculatePluginState ( itemId, this.config, item );
            // console.log('pc :: listShortcuts for item='+itemId, item.name, this.cache[itemId].shortcuts );
        }

        return this.cache[itemId].shortcuts;
    }

    listAvailable ( item:any ) {

        // got an item?
        if ( ! item ) { return []; }

        // id for this entry
        let itemId = this.config.createId(item);

        if ( ! this.cache[itemId] || this.cache[itemId].availableDirty ) {
            this.calculatePluginState ( itemId, this.config, item );
            // console.log('pc :: listAvailable for item='+itemId, item.name, this.cache[itemId].available );
        }

        return this.cache[itemId].available;
    }

    tellControllers ( action:string = 'update', data:any = null ) {
        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER :: TELL_CONTROLLERS', this, action, data ); }
        this.pluginManager.tellGuidPlugins ( this, action, data );
    }

    addController ( config:any = null ) {
        if ( !config ) {
            return null;
        }
        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: ADD_CONTROLLER', config ); }
        return this.create ( config.type, config, this );
    }

    create ( pluginControllerName:string, config:any = null, item:any = null ) {

        let ctrl = this.config;

        // this.debug = true;

        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: %c start CREATE ['+pluginControllerName+']', Constants._purple, config, item ); }

        // create a new instance
        let newPlugin = this.pluginManager.createProto(pluginControllerName);

        if ( newPlugin ) {

            // which controller created it?
            newPlugin.controller = this;

            if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: %c start CREATE ['+pluginControllerName+'] GOT PROTO', Constants._purple, newPlugin ); }

            if ( item ) {

                if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: %c start CREATE ['+pluginControllerName+'] GOT ITEM', Constants._purple, item ); }

                this.pluginManager.registerGuidObject ( item );

                if ( config ) {
                    if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: %c start CREATE ['+pluginControllerName+'] GOT CONFIG', Constants._purple, config ); }

                    newPlugin.updateConfig ( config );
                    if ( config.controller && newPlugin.hasOwnProperty('actionController') ) {
                        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: %c start CREATE ['+pluginControllerName+'] HAS CONTROLLER', Constants._purple ); }
                        newPlugin.actionController = config.controller;
                    }
                } else {
                    if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: %c start CREATE ['+pluginControllerName+'] NO CONFIG', Constants._purple ); }
                }

                // inject the associated item (scene, transform, annotation, whatever)
                newPlugin.itemId = ctrl.createId(item);
                newPlugin.injectItem(item);
            } else {
                if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: %c start CREATE ['+pluginControllerName+'] NO ITEM', Constants._purple ); }
            }

            // successfully created a plugin
            if ( this.pluginManager.set ( newPlugin.id, newPlugin ) ) {

                this.activePlugins.push(newPlugin.id);
                // console.log('ctrl create('+pluginId+')', n.id, this.activePlugins);
                this.clearCache(item);

                if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: %c start CREATE ['+pluginControllerName+'] UPDATED CACHE', Constants._purple ); }


                this.pluginManager.registerPluginToGuidObject ( item, newPlugin.id );


                if ( config && config['name'] ) {
                    this.lut[config['name']] = newPlugin.id;
                }

                if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: CREATE ['+pluginControllerName+'] %c SUCCESS ', Constants._green, item, config, newPlugin ); }

                // this.debug = false;
                return newPlugin.id;
            };
        }

        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: CREATE ['+pluginControllerName+'] %c FAIL ', Constants._red, item, config ); }
        
        // this.debug = false;
        return null;
    }

    getByName ( name:string = '' ) {
        if ( this.lut[name] ) {
            return this.pluginManager.get ( this.lut[name] );
        }
        return null;
    }

    getById ( id:string = '' ) {
        return this.pluginManager.get ( id );
    }

    // removes AND deletes from an item
    delete ( pluginId:string, item:any = null ) {
        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: delete %c ['+pluginId+']', Constants._green, pluginId, this.activePlugins, item ); }
        this.remove ( pluginId,item,true);
    }

    removeAllFromItem ( item:any = null ) {
        let these = this.listActive(item);
        if ( these && these.length ) {
            if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: removeAllFromItem()', these ); }
            these.forEach ( id => {
                this.remove(id,item);
            });
        }
    }

    // remove does not delete from an item
    remove ( pluginId:string, item:any = null, alsoDelete:boolean = false ) {

        // this.debug = true;

        this.activePlugins = this.activePlugins.filter ( p => p !== pluginId );

        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: remove ['+pluginId+'] %c START', Constants._green, pluginId, this.activePlugins, item ); }
        
        this.clearCache( item );
        if ( this.config.preRemove ) {
            if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: remove ['+pluginId+'] %c PRE_REMOVE', Constants._green, pluginId ); }
            this.config.preRemove ( pluginId, alsoDelete )
        }

        if ( alsoDelete ) {
            if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: remove ['+pluginId+'] %c DELETE', Constants._green, pluginId ); }
            this.pluginManager.delete ( pluginId );
        } else {
            if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: remove ['+pluginId+'] %c REMOVE', Constants._green, pluginId ); }
            this.pluginManager.remove ( pluginId );
        }
        

        if ( this.config.postRemove ) {
            if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: remove ['+pluginId+'] %c POST_REMOVE', Constants._green, pluginId ); }
            this.config.postRemove ( pluginId );
        }
        
        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: remove ['+pluginId+'] %c END ', Constants._green, pluginId, this.activePlugins.filter ( p => p !== pluginId ) ); }
        // console.log('@@@@@@@@@@@@@@@@@@@@@', pluginId, this.activePlugins, item );

        // this.debug = false;
    }

    end() {
        this.removeAll();
    }

    // removes all, but does not delete
    removeAll() {
        this.activePlugins.forEach(plug => {
            if ( this.pluginManager.check(plug) ) {
                this.remove ( plug, this.pluginManager.get(plug).item );
            }
        });
    }

    emptyAllControllers() {
        this.activePlugins.forEach(plug => {
            let plugin = this.pluginManager.get(plug);
            if ( plugin && plugin.actionController ) {
                plugin.actionController.unloadAllItems();
            }
        });
    }

    loadFrom ( item:any, sceneId:number ) {
        
        // find new ones to activate
        let plugins = this.findPluginsIn(item,sceneId);

        item['hasActivePlugins'] = plugins.length;
        this.countActive = plugins.length;

        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: loadFrom ['+item.id+'] %c found', Constants._green, plugins ); }

        // console.log('@@@@@@@@@@@@@@ loadFrom', item, sceneId, plugins );

        // create them
        if ( plugins && plugins.length > 0 ) {
            plugins.forEach ( pl => this.create(pl,null,item));
        }
    }

    findPluginsIn ( item:any, sceneId:number ) {
        let ret = [];
        let lookingfor = this.listAvailable(item);
        let id = this.config.createId(item);
        if ( item && item['_plugins'] && item['_plugins'][sceneId] ) {
            Object.keys(item['_plugins'][sceneId]).forEach(key => {
                if ( lookingfor.find( k => k == key ) ) {
                    ret.push(key);
                }
            });
        }
        
        if ( this.debug ) { console.log ('PLUGIN_CONTROLLER ['+this.label+'] :: findPluginsIn ['+item.id+'] %c found', Constants._green, lookingfor, ret ); }

        // console.log('pm :: findIn() --------- ', id, sceneId, lookingfor, ret, this.cache, item );
        return ret;
    }

}
